import { DateRange, FunctionType } from '@/types/item';

// Function color mapping
export const functionColors: Record<FunctionType, string> = {
  shop: '142 76% 36%', // Green
  specs: '221 83% 53%', // Blue 
  po: '262 83% 58%', // Purple
  contract: '25 95% 53%', // Orange
};

export const functionLabels: Record<FunctionType, string> = {
  shop: 'Shop',
  specs: 'Specs', 
  po: 'PO',
  contract: 'Contract',
};

// Calculate position and width of a bar based on date range
export const calculateBarPosition = (
  dateRange: DateRange,
  viewportStart: string,
  viewportEnd: string,
  cellWidth: number = 32 // 8 * 4px (w-8)
): { left: number; width: number; isVisible: boolean } => {
  const start = new Date(dateRange.start);
  const end = new Date(dateRange.end);
  const vpStart = new Date(viewportStart);
  const vpEnd = new Date(viewportEnd);

  // Check if bar is within viewport
  if (end < vpStart || start > vpEnd) {
    return { left: 0, width: 0, isVisible: false };
  }

  // Clamp start and end to viewport boundaries
  const visibleStart = start < vpStart ? vpStart : start;
  const visibleEnd = end > vpEnd ? vpEnd : end;

  // Calculate days from viewport start to visible start
  const daysSinceStart = Math.floor((visibleStart.getTime() - vpStart.getTime()) / (1000 * 60 * 60 * 24));
  
  // Calculate duration in days (inclusive: start date to end date)
  const durationInMs = visibleEnd.getTime() - visibleStart.getTime();
  const duration = Math.max(1, Math.floor(durationInMs / (1000 * 60 * 60 * 24)) + 1);

  return {
    left: daysSinceStart * cellWidth,
    width: duration * cellWidth,
    isVisible: true,
  };
};

// Get active gates for a function that have date ranges
export const getActiveGates = (functionData: any): Array<{ gate: string; dateRange: DateRange }> => {
  const gates: Array<{ gate: string; dateRange: DateRange }> = [];
  
  (['g1', 'g2', 'g3', 'g4', 'g5'] as const).forEach(gate => {
    if (functionData[gate]) {
      gates.push({ gate, dateRange: functionData[gate]! });
    }
  });
  
  return gates;
};